import Request from '@/utils/request'
import Store from '@/store'
import wx from 'weixin-js-sdk'
import Cookies from "js-cookie";

let util = {

};

util.title = function(meta) {
    window.document.title = meta.title ? meta.title : '2022杭州西湖论剑';
    document.querySelector('meta[name="keywords"]').setAttribute('content', meta.keywords ? meta.keywords : '2022杭州西湖论剑');
    document.querySelector('meta[name="description"]').setAttribute('content', meta.description ? meta.description : '2022杭州西湖论剑');
};

util.httpGet = function(path, params, auth) {
    if(!auth){
        Store.dispatch('login/login_open')
        return
    }
    return Request.get(path, {params})
};

util.userSourceChannel = function() {
    // 首访渠道
    if(!Cookies.get("ChannelFirst")){
        Cookies.set("ChannelFirst", window.location.href)
    }
    // 来源渠道
    if(!Cookies.get("ChannelSource")){
        Cookies.set("ChannelSource", window.document.referrer)
    }
};

util.httpPost = function(path, params, auth) {
    console.log(path, params, auth);
    if(!auth){

        Store.dispatch('login/login_open')
        return new Promise((resolve, reject)=>{

        })
    }
    return Request.post(path, params)
};

util.redirect = function(redirect) {
    window.location.href = redirect ? redirect : '/'
};


util.isIsWxClient  = function(redirect) {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    }
    return false;
};

util.wechatOnReady  = function(share) {
    wx.config(share.config);
    wx.ready(function(){

        console.log('开始配置微信参数')
        wx.updateTimelineShareData({
            title: share.title,    // 分享标题
            link: share.url,     // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share.cover,
            desc:share.postscript,
            success: function () {console.log('微信分享设置完毕1')}
        })

        wx.updateAppMessageShareData({
            title: share.title, // 分享标题
            desc: share.postscript, // 分享描述
            link: share.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: share.cover, // 分享图标
            success: function () {console.log('微信分享设置完毕2')}
        })
    });
};

util.wechatOauthRedirect = function() {
    let redirect = window.location.protocol + '//' + window.location.host;
    let str = 'wechat/redirect?redirect='+redirect+'/basics/register'
    return (process.env.NODE_ENV === 'development' ? process.env.VUE_APP_DEV_BASE_API : process.env.VUE_APP_BASE_API) + str;
}

util.registerUrl = function() {
    return window.location.protocol + '//' + window.location.host + '/basics/register';
}

export default util;
